import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { formatDate } from '@angular/common'; import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { APIHeaderService } from '../../_services/header/API-header';
import { saveAs as importedSaveAs } from "file-saver";

import { Router, ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-import-header',
  templateUrl: './import-header.component.html',
  styleUrls: ['./import-header.component.css']
})
export class ImportHeaderComponent implements OnInit {
  constructor(
    private fb: FormBuilder,
    private head: APIHeaderService,
    private db: $DBManagerService,
    private $modal: $ModalManagerService,
    private router: Router
  ) { }
  // uploadNcpr: FileList;
  importForm: FormGroup;
  submitted: boolean = false;
  compRadio: boolean = false;
  preferenceOrComplaint: any;
  photoName: any;
  photoContent: any;
  fileExtension: any;
  fileExtension1: any;
  filecheck: boolean = false;
  fileExtensionError: boolean = false;
  fileExtension1Error: boolean = false;
  fileExtension2Error: boolean = false;
  fileExtensionMessage: any;
  fileExtension1Message: any;

  complaintOptions: any;
  validfilecontent: boolean = true;
  uploadFile: string[];
  public Entity_Ref_No: any;
  public Entity_Name: any;
  headerOptions: any;
  myfiles: any[] = [];
  docfiles1: any;
  docfiles2: any;
  document1: any[] = [];
  document2: any[] = [];
  photoName1: any;
  orgType: any;
  Industry: any;
  Sector: any;
  addDocFlag: boolean = false;
  errDoc: boolean = false;
  fileSizeError1: boolean = false;
  fileSizeError2: boolean = false;
  uploader: string[];
  mobileNumber: any;
  email: any;
  emailIdSession: any;
  mobileNumberSession: any;
  peId: any;
  org_name: any;
  async ngOnInit() {
    if (this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_REF_NO_LOGIN) == null && this.db.get(Constants.SESSSION_STORAGE, Constants.Entity_EmailID) == null) {
      this.router.navigate(['/']);
    }

    console.log(this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_REF_NO_LOGIN))


    this.importForm = this.fb.group({
      uploadNcpr: ['', Validators.required],
      DocName: ['',],
      DocName1: ['',],
      uploader: ['',],
      uploader1: ['',],
      Entity_ID: ['',],
      Organization_Name: ['',],
      industry_type: ['',],
      sector: ['',],
    });
    this.peId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
    this.emailIdSession = this.db.get(Constants.SESSSION_STORAGE, Constants.Entity_EmailID);
    this.mobileNumberSession = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_MOBILE_NO);
    this.email = this.db.get(Constants.SESSSION_STORAGE, Constants.Entity_EmailID);
    this.org_name = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME);

    this.mobileNumber = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_MOBILE_NO);
    await this.fetchIndDetailsfrmDB(this.peId);
    await this.fetchEntityinHeadTempTable(this.peId);
  }
  get f() { return this.importForm.controls; }


  bulkUploadSchema(schema) {
    var fileName = 'HeaderTemplate.xlsx';
    const fields = ['S.No.', 'Header', 'HeaderType', 'Category', 'Nature', 'Description'];



    this.head.bulkUploadSchema(schema)
      .subscribe((r) => {
        importedSaveAs(r, fileName)
      })

  }


  fetchEntityinHeadTempTable(entityId) {
    this.head.fetchEntityinHeadTempTable(entityId)
      .subscribe((r) => {
        if (r.result == "" || r.result == undefined) {

          this.mobileNumber = this.mobileNumberSession;
          this.email = this.emailIdSession;


        }
        else {

          if (r.result[0].HeaderFlag == "false") {

            this.mobileNumber = this.mobileNumberSession;
            this.email = this.emailIdSession;

          }
          else if ((r.result[0].HeaderFlag == "true" || r.result[0].HeaderFlag == true) && (r.result[0].EVerifyFlag == "true" &&
            r.result[0].MVerifyFlag == "true")) {

            this.mobileNumber = r.result[0].MobileNumber;
            this.email = r.result[0].EmailId;

          }
          else if ((r.result[0].HeaderFlag == "true" || r.result[0].HeaderFlag == true) && (r.result[0].EVerifyFlag == "true" &&
            r.result[0].MVerifyFlag == "false")) {

            this.mobileNumber = this.mobileNumberSession;
            this.email = r.result[0].EmailId;

          }
          else if ((r.result[0].HeaderFlag == "true" || r.result[0].HeaderFlag == true) && (r.result[0].EVerifyFlag == "false" &&
            r.result[0].MVerifyFlag == "true")) {

            this.mobileNumber = r.result[0].MobileNumber;
            this.email = this.emailIdSession;
          }
          else {

            this.mobileNumber = this.mobileNumberSession;
            this.email = this.emailIdSession;
          }

        }
        this.importForm.controls['Entity_ID'].setValue(this.peId);
        this.importForm.controls['Organization_Name'].setValue(this.org_name);
        this.importForm.controls['industry_type'].setValue(this.Industry);
        this.importForm.controls['sector'].setValue(this.Sector);

      })

  }


  fileEvent(event): any {
    //*-- this function gets content of uploaded file and validation --

    var file = event.target.files[0];
    this.photoName = file.name;

    var allowedExtensions =
      ["csv"];
    this.fileExtension = this.photoName.split('.').pop();

    if (this.isInArray(allowedExtensions, this.fileExtension)) {
      this.fileExtensionError = false;
      this.fileExtensionMessage = ""
    } else {
      this.fileExtensionMessage = "Only photos allowed!!"
      this.fileExtensionError = true;
    }

    if (file) {
      var reader = new FileReader();
      reader.onloadend = (e: any) => {
        var contents = e.target.result;
        this.photoContent = contents;
      }
      reader.readAsDataURL(file);
    } else {
      alert("Failed to load file");
    }
    console.log("this is file extension error", this.fileExtensionError)
  }
  /*- checks if word exists in array -*/
  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }

  fetchIndDetailsfrmDB(entityId) {
    this.head.fetchIndDetailsfrmDB(entityId)
      .subscribe((r) => {
        console.log("r ", r);
        if (r !== undefined && r !== null) {
          this.Industry = r.Industry;
          this.Sector = r.Sector;
        }
        else {
          this.Industry = "";
          this.Sector = "";
        }

      })
  }


  onChangeHeaderOptions(event) {
    console.log("calling onChangeHeaderOptions")
    this.headerOptions = event.value;
  }
  //removing the file
  resetFile() {
    console.log(this.importForm.controls['uploadNcpr'].value);
    this.importForm.controls['uploadNcpr'].reset();
    console.log(this.importForm.controls['uploadNcpr'].value);

  }




  //end of my commits
  onChangeFileUpload(event) {
    //my commits
    console.log("calling onChangeFileUpload");
    var file = event.target.files[0];
    let fileNameArr = file.name.split('.')
		if(fileNameArr.length>2){
      // this.fileDoubleExtensionError = true
      this.$modal.errorModal({
        title: 'Import Header',
        msg: 'File with double extension is not allowed!' 
      })
      this.resetKYC()
    }else{
      var allowedExtensions =
      ["xlsx"];
    this.fileExtension = file.name.split('.').pop();
    if (this.isInArray(allowedExtensions, this.fileExtension)) {
      console.log('test');
      this.fileExtension2Error = false;
      var files = event.srcElement.files;
      console.log("this.headerOptions", this.headerOptions)
      var input = event.target;
      var reader = new FileReader();
      reader.readAsText(input.files[0]);
      reader.onload = (data) => {
        let csvData = reader.result;
        let csvRecordsArray = (csvData as string).split(/\r\n|\n/);
        // let csvRecordsArray = csvData.split(/\r\n|\n/);
        // let headersRow = this.getHeaderArray(csvRecordsArray);
      }
      //end of commits
      this.uploadFile = event.target.files;
      console.log("this.uploadFile :", this.uploadFile);
    }
    else {
      this.fileExtension2Error = true;
    }
    }
  }



  resetKYC() {
    console.log(this.importForm.controls['uploadNcpr'].value);
    this.importForm.controls['uploadNcpr'].reset();
    console.log(this.importForm.controls['uploadNcpr'].value);

  }



  submitHeaderDocument(event, id) {

    this.myfiles = event.target.files;
    var file = event.target.files[0];
    let fileNameArr = file.name.split('.')
		if(fileNameArr.length>2){
      // this.fileDoubleExtensionError = true
      this.$modal.errorModal({
        title: 'Import Header',
        msg: 'File with double extension is not allowed!' 
      })
      if (id == "doc1") {
				this.resetDoc1()
			}
			else if (id == "doc2") {
				this.resetDoc2()
			}
    }else{
      if (id == "doc1") {
        this.photoName = file.name;
        this.docfiles1 = this.document1.push(file);
      }
      else if (id == "doc2") {
        this.photoName1 = file.name;
        this.docfiles2 = this.document2.push(file)
      }
  
      if (file.size > 4242880) {
        console.log("The size is more ")
        this.fileSizeError1 = true;
      }
      else {
        this.fileSizeError1 = false;
      }
      if (file.size <= 0) {
        console.log("The size is less ")
        this.fileSizeError2 = true;
      }
      else {
        this.fileSizeError2 = false;
      }
      var allowedExtensions =
        ["pdf", "zip"];
      this.fileExtension = this.photoName.split('.').pop();
  
      if (this.photoName1) {
        this.fileExtension1 = this.photoName1.split('.').pop();
      }
  
  
      if (this.isInArray(allowedExtensions, this.fileExtension)) {
        console.log('test');
        this.fileExtensionError = false;
        this.fileExtensionMessage = ""
      }
      else {
        this.fileExtensionMessage = "Only photos allowed!!"
        this.fileExtensionError = true;
      }
      if (this.isInArray(allowedExtensions, this.fileExtension1)) {
        console.log('test');
        this.fileExtension1Error = false;
        this.fileExtension1Message = ""
      }
      else {
        this.fileExtension1Message = "Only photos allowed!!"
        this.fileExtension1Error = true;
      }
  
      if (file) {
        var reader = new FileReader();
        reader.onloadend = (e: any) => {
          var contents = e.target.result;
          this.photoContent = contents;
        }
        reader.readAsDataURL(file);
      } else {
        alert("Failed to load file");
      }
      console.log("this is file extension error", this.fileExtensionError);
    }
  }



  fileRead(photoNam, fil) {
    var allowedExtensions = ["zip", "pdf"];
    this.fileExtension = photoNam.split('.').pop();
    if (this.isInArray(allowedExtensions, this.fileExtension)) {
      this.fileExtensionError = false;
      this.fileExtensionMessage = ""
    } else {
      this.fileExtensionMessage = "Only photos allowed!!"
      this.fileExtensionError = true;
    }

    if (fil) {
      var reader = new FileReader();
      reader.onloadend = (e: any) => {
        var contents = e.target.result;
        this.photoContent = contents;
      }
      reader.readAsDataURL(fil);
    } else {
      alert("Failed to load file");
    }
    console.log("this is file extension error", this.fileExtensionError);
  }

  addDocument() {
    if (this.addDocFlag == true) {
      this.errDoc = true;
    }
    else {
      this.addDocFlag = true;
    }
  }


  resetDoc1() {
    console.log(this.importForm.controls['uploader'].value);
    this.importForm.controls['uploader'].reset();
    this.docfiles1 = null;
    console.log(this.importForm.controls['uploader'].value);
    this.document1 = [];
  }

  resetDoc2() {
    console.log(this.importForm.controls['uploader1'].value);
    this.importForm.controls['uploader1'].reset();
    this.docfiles2 = null;
    console.log(this.importForm.controls['uploader1'].value);
    //this.addDocFlag = false;
    this.document2 = [];
  }

  onSubmit() {
    this.Entity_Ref_No = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_REF_NO_LOGIN);
    this.Entity_Name = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_NAME);
    this.orgType = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_TYPE);
    console.log("this.orgType --- ", this.orgType);
    this.submitted = true;
    const importForm: FormData = new FormData();
    let now = new Date();
    const uploadDate = formatDate(now, 'yyyy-MM-dd', 'en-US', '+0530');
    const file1: any = document.getElementById('uploadNcpr');
    console.log("file changed:", file1.files[0])
    console.log("my comments:", file1)

    console.log("preferenceOrComplaint", this.preferenceOrComplaint)
    console.log("validfilecontent", this.validfilecontent)
    if (this.importForm.invalid) {
      console.log("Invalid form: ", this.importForm);
      this.$modal.errorModal({
        title: 'Import Header',
        msg: 'Please upload a File'
      });
      return;
    }

    else if ((this.validfilecontent == true)) {

      let peId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
      let email = this.db.get(Constants.SESSSION_STORAGE, Constants.Entity_EmailID);
      let mobile = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_MOBILE_NO);
      let E_Org_Name = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME);

      console.log("importForm", this.importForm);
      importForm.append('uploadDate', uploadDate);
      importForm.append('Entity_Ref_No', this.Entity_Ref_No);
      importForm.append('Entity_Name', this.Entity_Name);
      importForm.append('PeId', peId);
      importForm.append('file1', file1.files[0]);
      importForm.append('Entity_Type', "Principal Entity");

      importForm.append('IndustryType', this.orgType);

      importForm.append('Industry', this.Industry);
      importForm.append('Sector', this.Sector);

      importForm.append('OrgName', E_Org_Name);
      importForm.append('document1', this.document1[0]);
      importForm.append('document2', this.document2[0]);
      let documentName = this.importForm.get("DocName").value;
      let documentName1 = this.importForm.get("DocName1").value;
      importForm.append('DocName', documentName);
      importForm.append('DocName1', documentName1);
      // importForm.append('Entity_Email', email); 
      // importForm.append('Entity_Mobile', mobile);
      importForm.append('Entity_Email', this.email);
      importForm.append('Entity_Mobile', this.mobileNumber);

      console.log("importForm ---> ", importForm);

      this.head.importHeader(importForm)
        .subscribe(r => {


          console.log("response : ", r);
          console.log("r.status :", r.status);
          if (r.status == "success") {
            if (r.status == "success") {
              this.$modal.successModal({
                title: 'Import Header',
                msg: 'Header File has been uploaded Successfully! \n \n  Your Batch ID is ' + r.BatchId
              });

              this.router.navigateByUrl('/header-summary');
            }
          }
          //Added for Government
          //commented for Government
          // else if(r.status == "fail"){
          //   this.$modal.errorModal({
          //     title: 'Import Header',
          //     msg: 'Invalid File Format!'
          //   });
          // }
          else if (r.err) {
            if (r.err == "Exceeds more than 10") {
              this.$modal.errorModal({
                title: 'Import Header',
                msg: 'File contains more than 10 Records!'
              });
            }
            if (r.err == "empty values") {
              this.$modal.errorModal({
                title: 'Import Header',
                msg: 'Header cannot be empty!'
              });
            }
             //Added for Hclass
             else {
              this.$modal.errorModal({
                title: 'Import Header',
                msg: r.err
              });
            }
          }

          else if (r.status == "duplicate") {
            this.$modal.errorModal({
              title: 'Import Header',
              msg: 'File contains Duplicate Records!'
            });
          }
          else if (r.status == "failed") {
            this.$modal.errorModal({
              title: 'Import Header',
              msg: 'Header upload failed due to invalid data!'
            });
          }

        })
    }
    else {
      alert("upload a valid CSV File");
    }
  }
}
